import * as React from "react";
import { BookOpen, SquareUserRound } from "lucide-react";
import { NavMain } from "../ui/NavMain";
import {
  Sidebar,
  SidebarContent,
  SidebarRail,
} from "../../components/shadcn-ui/sidebar";
import { dashBoardOptions } from "../../pages/dashboard/dashBoardOption";

export const data = {
  user: {
    name: "User",
    email: "user@example.com",
    avatar: "",
  },
  navMain: [
    {
      title: "Leads",
      url: "#",
      icon: SquareUserRound,
      items: [
        {
          title: "Create New Lead",
          url: "/dashboard/leads/create-lead",
        },
        {
          title: "Show All Leads",
          url: "/dashboard/leads/list/v2",
        },
      ],
    },
    {
      title: "Loan Application",
      url: "#",
      icon: BookOpen,
      items: [
        {
          title: "Start New Application",
          url: "/dashboard/loan/create-application",
          icon: BookOpen,
        },
        {
          title: "Show All Applications",
          url: "/dashboard/loan/application/list",
        },
      ],
    },
  ],
};

export function SideNav({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar
      collapsible="icon"
      {...props}
      style={{
        height: "calc(100vh - 90px)",
        overflow: "hidden",
        backgroundColor: "#fff",
      }}
    >
      <SidebarContent>
        <NavMain items={dashBoardOptions} />
      </SidebarContent>
      <SidebarRail />
    </Sidebar>
  );
}
